import { render, staticRenderFns } from "./ShowcaseYourAnimationPopup.vue?vue&type=template&id=86474fca&"
import script from "./ShowcaseYourAnimationPopup.vue?vue&type=script&lang=js&"
export * from "./ShowcaseYourAnimationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports